<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="产品代码">
              <a-input
                placeholder="请输入产品代码"
                v-model="fundCode"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="产品名称">
              <a-input
                placeholder="请输入产品名称"
                v-model="fundName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="栏目">
              <a-tree-select
                v-model="columnId"
                allowClear
                class="lm"
                :tree-data="columnChannel"
                placeholder="请选择关联栏目"
                @change="handleChange"
              >
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />批量删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无文件</span
          >
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)"
          >
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a
            :disabled="record.isReview == '1' ? true : false"
            @click="handleAudit(record)"
            >审核</a
          >
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a
            :disabled="record.isReview == '1' ? true : false"
            @click="handleDelete(record.id)"
            >删除</a
          >
        </span>
      </a-table>
    </div>
    <a-modal
      v-model="checkVisible"
      title="审核"
      @cancel="checkVisible == false"
    >
      <template slot="footer">
        <a-button @click="handleReview(2)">审核驳回</a-button>
        <a-button type="primary" @click="handleReview(1)">审核通过</a-button>
      </template>
      <a-form :labelCol="{ span: 5 }" :wrapperCol="{ span: 14 }">
        <a-form-item label="产品名称">
          <a-input
            placeholder="请输入产品名称"
            v-model="currentProduct.fundName"
            disabled
          ></a-input>
        </a-form-item>
        <a-form-item label="产品代码">
          <a-input
            placeholder="请输入产品代码"
            v-model="currentProduct.fundCode"
            disabled
          ></a-input>
        </a-form-item>
        <a-form-item label="栏目">
          <a-input
            placeholder="请输入栏目"
            v-model="currentProduct.columnName"
            disabled
          ></a-input>
        </a-form-item>
        <a-form-item label="推荐理由">
          <a-textarea
            :auto-size="{ minRows: 3, maxRows: 3 }"
            placeholder="请输入产品推荐理由"
            v-model="currentProduct.reason"
            disabled
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
    <productsRecommended-modal
      :columnChannel="columnChannel"
      ref="modalForm"
      @ok="modalFormOk"
    ></productsRecommended-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { filterObj } from '@/utils/util';
import ProductsRecommendedModal from './modules/ProductsRecommendedModal';
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue';
import { uploadAction, postAction, getAction, postTag } from '@/api/manage';
import { findTreeNodeArray } from '@/utils/common';
export default {
  name: 'ProductsRecommendedList',
  components: {
    JDictSelectTag,
    ProductsRecommendedModal
  },
  data() {
    return {
      checkVisible: false, //审核弹窗
      currentProduct: {},
      // 表头
      fundCode: '',
      fundName: '',
      columns: [
        {
          title: '产品代码',
          align: 'center',
          dataIndex: 'fundCode',
          width: 100
        },
        {
          title: '产品名称',
          align: 'center',
          dataIndex: 'fundName',
          ellipsis: true,
          width: 170
        },
        {
          title: '推荐理由',
          align: 'center',
          dataIndex: 'reason',
          ellipsis: true,
          width: 200
        },
        {
          title: '栏目',
          align: 'center',
          dataIndex: 'columnName',
          ellipsis: true,
          width: 100
        },
        {
          title: '索引排序',
          align: 'center',
          dataIndex: 'indexSort',
          width: 80,
          ellipsis: true
        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'isReview',
          customRender: text => {
            if (text == 0) {
              return '未审核';
            } else if (text == 1) {
              return '已审核';
            } else if (text == 2) {
              return '已驳回';
            }
          },
          width: 100
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ],
      columnChannel: [], //栏目渠道
      loading: false,
      queryParam: {
        fundCode: '',
        fundName: ''
      },
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      columnId: '', //栏目ID
      columnName: [], //栏目名字,
      columnCode: '',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      url: {
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/recommended/page',
        auditReview:
          process.env.VUE_APP_CMS_PRODUCT + '/product/recommended/review',
        delete: process.env.VUE_APP_CMS_PRODUCT + '/product/recommended/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT + '/product/recommended/deleteBatch'
      }
    };
  },
  created() {
    this.initData();
    this.getList();
  },
  computed: {},
  methods: {
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        pageNo: that.ipagination.current,
        pageSize: that.ipagination.pageSize,
        fundCode: this.fundCode,
        fundName: this.fundName,
        columnCode: this.columnCode
      };
      postTag(that.url.list, params)
        .then(res => {
          that.loading = true;
          if (res.success) {
            res.result.records.map(item => {
              console.log(item);
              if (
                item.recommendedSubs != null &&
                item.recommendedSubs.length > 0
              ) {
                let columArr = [];
                item.recommendedSubs.map(pre => {
                  columArr.push(pre.columnName);
                  item.columnName = columArr.toString();
                });
              }
            });
            that.dataSource = res.result.records;
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    //审核
    handleAudit(record) {
      console.log(record);

      this.checkVisible = true;
      this.currentProduct = record;
      // }
    },
    // 审核
    handleReview(flg) {
      let that = this;
      let param = {
        id: this.currentProduct.id,
        isReview: flg,
        reason: ''
      };
      that.loading = true;
      postTag(that.url.auditReview, param)
        .then(res => {
          that.checkVisible = false;
          if (res.success) {
            that.getList();
            that.$message.success(res.message);
          } else {
            that.$message.error(res.message);
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //添加
    handleAdd() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      this.queryParam.columnId = this.columnName.join(',');
      let param = Object.assign(sqp, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    // 编辑
    handleEdit(record) {
      console.log(record);
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    // 批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //删除
    handleDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then(res => {
              if (res.success) {
                that.getList();
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    //查询
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      // this.queryParam = {};
      this.columnCode = '';
      this.fundCode = '';
      this.fundName = '';
      this.columnId = [];
      this.columnName = [];
      console.log(this.columnId);
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    //清空所选中的数据
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
    //获取栏目数据
    initData() {
      getAction(
        process.env.VUE_APP_CMS_CONTENT + '/content/column/queryByChannel',
        { channelCode: 'pc_service' }
      ).then(res => {
        if (res.success) {
          this.columnChannel = res.result;
        }
      });
    },
    //获取渠道栏目Id
    handleChange(value, label, extra) {
      // console.log(value, label, extra.triggerNode.dataRef.code);
      // this.columnName = value;
      // this.columnCode = extra.triggerNode.dataRef.code;
      this.handleChannelData([value]);
    },
    handleChannelData(value) {
      let arr = findTreeNodeArray('children', this.columnChannel, e => {
        return value.filter(item => item == e.id).length > 0;
      });
      this.columnName = value[0];
      this.columnCode = arr[0] ? arr[0].code : '';
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
